<!-- 下拉选择返回数组 -->
<template>
  <div>
    <el-select v-model="selfActiveList" class="w-100" size="mini" :multiple="multiple" clearable>
      <el-option
        v-for="(item, index) in allList"
        :key="index"
        :label="item.key"
        :value="item.val"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    allList: {
      type: Array,
      required: true
    },
    activeList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selfActiveValue: []
    }
  },
  computed: {
    // 将单选值转换为数组
    selfActiveList: {
      get() {
        return this.selfActiveValue
      },
      set(newVal) {
        let result = []
        if (newVal.length) result = this.multiple ? [...newVal] : [newVal]
        this.selfActiveValue = this.$util.deepCopy(result)
        this.$emit('update:activeList', this.$util.deepCopy(result))
      }
    }
  },
  watch: {
    activeList: {
      handler(val) {
        if (JSON.stringify(this.selfActiveList) !== JSON.stringify(val)) {
          if (this.multiple) {
            this.selfActiveValue = val
          } else {
            this.selfActiveValue = val ? val[0] : null
          }
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
